import { Row as CoreRow } from '@lib/core/src/styledComponents/StyledComponents';
import palette from '@lib/core/src/theme/palette';
import { Box, Button, List, ListItem, Stack, styled, Typography } from '@mui/material';

export const TranscriptListBlock = styled(Stack)({
  height: 'calc(100% - 31px)',
  paddingTop: '1vh',
  position: 'relative'
});

export const Title = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '120%'
}));

export const TranscriptList = styled(List)(() => ({
  overflow: 'auto',
  flex: 1,
  padding: 0,
  scrollbarWidth: 'thin'
}));

export const TranscriptText = styled(Typography)(() => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px'
}));

export const TranscriptSpeaker = styled(Typography)(() => ({
  fontSize: '12px',
  color: palette.title.grey,
  fontWeight: 500,
  lineHeight: '16px'
}));

export const TranscriptHeader = styled(Stack)(() => ({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const SyncButton = styled(Button)(() => ({
  borderRadius: '4px',
  backgroundColor: palette.grey[200],
  border: `1px solid ${palette.grey[1200]}`,
  padding: '4px 8px',
  color: palette.grey[500],
  fontSize: '11px',
  textTransform: 'none',
  fontWeight: 500
}));

export const TranscriptListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== 'isActive'
})<{ isActive: boolean }>(({ isActive }) => {
  const activeHoverStyles = {
    backgroundColor: palette.grey[1100],
    borderRadius: '2px'
  };

  return {
    padding: '10px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    ...(isActive && { ...activeHoverStyles, borderLeft: `2px solid ${palette.black}` }),
    '&:hover': {
      ...activeHoverStyles,
      '& .transcript-date': {
        color: palette.typography.blue
      }
    }
  };
});

export const TranscriptDate = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isActive'
})<{ isActive?: boolean }>(({ isActive }) => ({
  fontWeight: 500,
  fontSize: '12px',
  color: isActive ? palette.typography.blue : palette.grey[500],
  cursor: 'pointer',
  marginBottom: '3px',
  lineHeight: '14px'
}));

export const TranscriptFadeBlock = styled(Box)(() => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  height: 20,
  background: `linear-gradient(180deg, rgba(248, 248, 248, 0.00) 0%,${palette.grey[100]} 79.41%)`,
  pointerEvents: 'none',
  zIndex: 1
}));

export const Container = styled(Stack)({
  height: '100%'
});

export const Row = styled(CoreRow)({
  gap: '8px'
});

export const StartStack = styled(Stack)({
  gap: '4px',
  alignItems: 'start',
  width: '100%'
});

export const SpaceBetweenRow = styled(Row)({
  justifyContent: 'space-between',
  width: '100%'
});
